import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';

import { cn } from 'helpers/css';

const Checkbox = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        `tw-peer tw-h-4 tw-w-4 tw-shrink-0 tw-rounded tw-border tw-border-black dark:tw-border-white tw-shadow focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring disabled:tw-cursor-not-allowed disabled:tw-opacity-50`,

        // State handler
        `data-[state=checked]:tw-bg-primary data-[state=checked]:tw-text-primary-foreground data-[state=checked]:tw-border-primary dark:data-[state=checked]:tw-border-primary`,
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn('tw-flex tw-items-center tw-justify-center tw-text-current')}
      >
        <Check className='tw-h-4 tw-w-4' />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
